import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type UnpublishCampaignSuccessModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function UnpublishCampaignSuccessModal({ isOpen, handleClose }: UnpublishCampaignSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="unpublish-campaign-success">
      <AcknowledgeModal
        result="positive"
        title={t('typography.givingCampaigns.unpublishCampaign.success.title')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="success-modal-btn"
      >
        {t('typography.givingCampaigns.unpublishCampaign.success.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
